<template>
  <div>
    <div v-if="$store.state.user.clientID" :key="$root.time">
      <h1 class="main-heading">Industry & Agriculture</h1>
      <SectionNavigator
        :sections="$root.industryAndAgriculture.sections"
        :schemas="$root.industryAndAgriculture.schemas"
      />
      <router-view />
    </div>
  </div>
</template>

<script>
import SectionNavigator from '../SectionNavigator'

// import routes from '../../router/index'
export default {
  name: 'category-industry-and-agriculture',
  props: { sections: String, schemas: Array },
  components: {
    SectionNavigator
  }
}
</script>
